import { render, staticRenderFns } from "./OpportunityDocuments.vue?vue&type=template&id=4607c1bd"
import script from "./OpportunityDocuments.vue?vue&type=script&lang=js"
export * from "./OpportunityDocuments.vue?vue&type=script&lang=js"
import style0 from "./OpportunityDocuments.vue?vue&type=style&index=0&id=4607c1bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports